import { EventStatusId, ResultId } from '@collector/sportsapi-client-legacy'

export type ResultWithSliderConfig<
  T1 extends ResultId = ResultId,
  T2 extends EventStatusId = EventStatusId,
> = {
  resultIdToAcronymMap: Map<T1, string>
  eventStatusToResultIdMap: Map<T2, T1>
  showCurrentResult?: boolean
}

/**
 * Creates a map of `ResultId` values to acronyms using a specified `prefix` and sequential numbering.
 *
 * @param resultIds - Array of `ResultId` values to map
 * @param prefix - The prefix to use for acronyms (e.g., "In" for innings)
 * @returns A Map where each `ResultId` is mapped to its acronym (e.g., "In1", "In2", etc.)
 */
export function createResultIdToAcronymMap<T extends ResultId>(
  resultIds: T[],
  prefix: string,
): Map<T, string> {
  return new Map(
    resultIds.map((resultId, index) => [resultId, `${prefix}${index + 1}`]),
  )
}
